import { useQuery } from '@tanstack/react-query';

import type { CommunityScheduledPostsResponse } from '~/interfaces/community';

export const SCHEDULED_POSTS_PATH = '/community/scheduled_posts';

// Its own key: the feed's cache updates assume paginated posts, and its prefix invalidations would refetch the queue.
export const SCHEDULED_POSTS_QUERY_KEY = ['community-scheduled-posts'];

const useCommunityScheduledPosts = ({ enabled }: { enabled: boolean }) =>
  useQuery<CommunityScheduledPostsResponse>({
    queryKey: SCHEDULED_POSTS_QUERY_KEY,
    queryFn: async ({ signal }) => {
      const response = await fetch(SCHEDULED_POSTS_PATH, { signal });
      if (!response.ok) throw new Error('Failed to fetch the scheduled posts');

      return response.json();
    },
    enabled,
  });

export default useCommunityScheduledPosts;
